
export const _form = () => {
	const continueOne = document.querySelector(".c-stage-form__button-continue-1");
	const continueTwo = document.querySelector(".c-stage-form__button-continue-2");
	const backOne = document.querySelector(".c-stage-form__button-back-1");
	const backTwo = document.querySelector(".c-stage-form__button-back-2");
	const stepOne = document.querySelector(".c-stage-form__step--1");
	const stepTwo = document.querySelector(".c-stage-form__step--2");
	const stepThree = document.querySelector(".c-stage-form__step--3");
	const formContentOne = document.querySelector(".c-stage-form__content--one");
	const formContentTwo = document.querySelector(".c-stage-form__content--two");
	const formContentThree = document.querySelector(".c-stage-form__content--three");
	const checkboxes = document.querySelectorAll('.c-stage-form__checkbox');
	const spinner = document.querySelectorAll(".c-stage-form__spinner");

	if( formContentOne ) {
		formContentOne.classList.add('is-active');
		stepOne.classList.add('is-active');
	}

	if ( continueOne ) {
		continueOne.addEventListener( 'click', () => {

			spinner.forEach(element => {
				element.classList.add("is-active");

				setTimeout(() => {
					element.classList.remove("is-active");
					formContentOne.classList.remove('is-active');
					stepOne.classList.remove('is-active');
					formContentTwo.classList.add('is-active');
					stepTwo.classList.add('is-active');
				}, 1000);
			});
		} )

		continueTwo.addEventListener( 'click', () => {
			spinner.forEach(element => {
				element.classList.add("is-active");

				setTimeout(() => {
					element.classList.remove("is-active");
					formContentTwo.classList.remove('is-active');
					stepTwo.classList.remove('is-active');
					formContentThree.classList.add('is-active');
					stepThree.classList.add('is-active');
				}, 1000);
			});
		} )

		backOne.addEventListener( 'click', () => {
			spinner.forEach(element => {
				element.classList.add("is-active");

				setTimeout(() => {
					element.classList.remove("is-active");
					formContentTwo.classList.remove('is-active');
					stepTwo.classList.remove('is-active');
					formContentOne.classList.add('is-active');
					stepOne.classList.add('is-active');
				}, 1000);
			});
		} )

		backTwo.addEventListener( 'click', () => {
			spinner.forEach(element => {
				element.classList.add("is-active");

				setTimeout(() => {
					element.classList.remove("is-active");
					formContentThree.classList.remove('is-active');
					stepThree.classList.remove('is-active');
					formContentTwo.classList.add('is-active');
					stepTwo.classList.add('is-active');
				}, 1000);
			});
		} )

		checkboxes.forEach( check => {
			check.addEventListener('click', () => {
				check.classList.toggle('checked');
			})
		})
	}
}
